import { UserManager, WebStorageStateStore, type UserManagerSettings } from "oidc-client-ts";
import Configuration from "@common/Configuration";

// Multi-tenant: l'authority OIDC (realm del macro-cliente) NON è più cablata via
// env, ma SCOPERTA a runtime dall'identificativo di login (Home Realm Discovery)
// e persistita, così un reload ricostruisce lo stesso UserManager senza ri-fare
// la discovery. Vedi LoginPage (identifier-first) + AuthBootstrap (main.tsx).

const AUTHORITY_KEY = "mdb.authority";

export function getPersistedAuthority(): string | null {
  return window.localStorage.getItem(AUTHORITY_KEY);
}

export function persistAuthority(authority: string): void {
  window.localStorage.setItem(AUTHORITY_KEY, authority);
}

/** Pulisce l'authority persistita (al logout) → il prossimo accesso riparte da identifier-first. */
export function clearPersistedAuthority(): void {
  window.localStorage.removeItem(AUTHORITY_KEY);
}

const LOGIN_HINT_KEY = "mdb.loginHint";

/** Ultimo identificativo inviato (username/email), per precompilare la login. Mai la password. */
export function getPersistedLoginHint(): string | null {
  return window.localStorage.getItem(LOGIN_HINT_KEY);
}

export function persistLoginHint(hint: string): void {
  window.localStorage.setItem(LOGIN_HINT_KEY, hint);
}

export function clearPersistedLoginHint(): void {
  window.localStorage.removeItem(LOGIN_HINT_KEY);
}

export function buildOidcSettings(authority: string): UserManagerSettings {
  return {
    authority,
    client_id: Configuration.VITE_CONFIG_KEYCLOAK_CLIENT_ID,
    redirect_uri: `${window.location.origin}/callback`,
    post_logout_redirect_uri: window.location.origin,
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };
}

let currentUserManager: UserManager | null = null;

/** Crea (o ricrea) il UserManager per l'authority data e lo registra come corrente. */
export function initUserManager(authority: string): UserManager {
  currentUserManager = new UserManager(buildOidcSettings(authority));
  return currentUserManager;
}

/** UserManager corrente (inizializzato dall'AuthBootstrap), o null se il realm non è ancora noto. */
export function getUserManager(): UserManager | null {
  return currentUserManager;
}
